import apiEndpoints from '../../../apiEndpoints';
import { fetcher } from '../../utils/fetchers/fetcher';
import {
  GuideDetail,
  GuideIndex,
  GuideProgressItem,
  GuideProgressKind,
  GuideProgressStatus,
  PathDefinition,
  TourDefinition,
} from '../../../types/guides';

export const requestGuideIndex = (token: string | null): Promise<GuideIndex> =>
  fetcher<GuideIndex>(apiEndpoints.routes.guides, 'GET', token);

export const requestGuide = (
  guideId: string,
  token: string | null
): Promise<{ version: string; guide: GuideDetail }> =>
  fetcher(
    `${apiEndpoints.routes.guides}/${encodeURIComponent(guideId)}`,
    'GET',
    token
  );

export const requestTour = (
  tourId: string,
  token: string | null
): Promise<{ version: string; tour: TourDefinition }> =>
  fetcher(
    `${apiEndpoints.routes.tours}/${encodeURIComponent(tourId)}`,
    'GET',
    token
  );

export const requestPath = (
  pathId: string,
  token: string | null
): Promise<{ version: string; path: PathDefinition }> =>
  fetcher(
    `${apiEndpoints.routes.paths}/${encodeURIComponent(pathId)}`,
    'GET',
    token
  );

export const requestGuideProgress = (
  token: string | null
): Promise<{ items: GuideProgressItem[] }> =>
  fetcher(apiEndpoints.routes.guideProgress, 'GET', token);

export const postGuideProgress = (
  token: string | null,
  body: {
    kind: GuideProgressKind;
    itemId: string;
    status: GuideProgressStatus;
    step: number | null;
  }
): Promise<{ item: GuideProgressItem }> =>
  fetcher(
    apiEndpoints.routes.guideProgress,
    'POST',
    token,
    undefined,
    undefined,
    body
  );
